/**
 * Element secim modunun sayfa uzerindeki gorsel katmani.
 *
 * Musteri sitesinin CSS'i bilinmedigi icin tum stiller inline verilir ve
 * yuksek z-index kullanilir. Secim modunda tiklamalar yakalanir (sayfa gezinmez);
 * kullanici Alt tusunu basili tutarsa normal gezinme calisir.
 */

const Z_INDEX = 2147483000;
const HIGHLIGHT_COLOR = "#14b8a6";

function createBox(styles) {
    const node = document.createElement("div");
    node.style.position = "fixed";
    node.style.pointerEvents = "none";
    node.style.zIndex = String(Z_INDEX);
    node.style.display = "none";
    Object.keys(styles).forEach(function (key) {
        node.style[key] = styles[key];
    });
    return node;
}

class EditorOverlay {
    constructor() {
        this.active = false;
        this.root = null;
        this.outline = null;
        this.label = null;
        this.banner = null;
        this.hovered = null;
        this.altPressed = false;
        this.onSelect = null;
        this.bannerText = "";
        this.boundHandlers = null;
    }

    ensureNodes() {
        if (this.root) return;

        this.root = document.createElement("div");
        this.root.setAttribute("data-supsis-editor", "overlay");

        this.outline = createBox({
            border: "2px solid " + HIGHLIGHT_COLOR,
            background: "rgba(20, 184, 166, 0.12)",
            borderRadius: "3px",
            transition: "all 60ms linear",
        });

        this.label = createBox({
            background: "#0f172a",
            color: "#ffffff",
            font: "500 12px/1.4 -apple-system, Segoe UI, Roboto, sans-serif",
            padding: "4px 8px",
            borderRadius: "4px",
            whiteSpace: "nowrap",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        });

        this.banner = createBox({
            left: "50%",
            top: "16px",
            transform: "translateX(-50%)",
            background: "#0f172a",
            color: "#ffffff",
            font: "500 13px/1.5 -apple-system, Segoe UI, Roboto, sans-serif",
            padding: "8px 14px",
            borderRadius: "999px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
        });

        this.root.appendChild(this.outline);
        this.root.appendChild(this.label);
        this.root.appendChild(this.banner);
        document.documentElement.appendChild(this.root);
    }

    /**
     * Secim modunu acar.
     * @param {Function} onSelect secilen element ile cagrilir
     * @param {String} bannerText ust bilgi metni
     */
    start(onSelect, bannerText) {
        this.ensureNodes();
        this.active = true;
        this.onSelect = onSelect;
        this.bannerText = bannerText || "";

        this.banner.textContent = this.bannerText;
        this.banner.style.display = this.bannerText ? "block" : "none";
        document.documentElement.style.cursor = "crosshair";

        this.bindHandlers();
    }

    stop() {
        this.active = false;
        this.hovered = null;
        this.onSelect = null;
        if (this.outline) this.outline.style.display = "none";
        if (this.label) this.label.style.display = "none";
        if (this.banner) this.banner.style.display = "none";
        document.documentElement.style.cursor = "";
    }

    bindHandlers() {
        if (this.boundHandlers) return;
        const self = this;

        this.boundHandlers = {
            move: function (event) {
                if (!self.active || self.altPressed) return;
                self.highlightElement(event.target);
            },
            click: function (event) {
                if (!self.active || self.altPressed) return;
                event.preventDefault();
                event.stopPropagation();
                const element = event.target;
                const handler = self.onSelect;
                self.stop();
                if (handler) handler(element);
            },
            keyDown: function (event) {
                if (event.key === "Alt") self.altPressed = true;
                // Escape ile secim modundan cikilir
                if (event.key === "Escape" && self.active) self.stop();
            },
            keyUp: function (event) {
                if (event.key === "Alt") self.altPressed = false;
            },
            scroll: function () {
                if (self.active && self.hovered) self.highlightElement(self.hovered);
            },
        };

        document.addEventListener("mousemove", this.boundHandlers.move, true);
        document.addEventListener("click", this.boundHandlers.click, true);
        document.addEventListener("keydown", this.boundHandlers.keyDown, true);
        document.addEventListener("keyup", this.boundHandlers.keyUp, true);
        window.addEventListener("scroll", this.boundHandlers.scroll, true);
    }

    /** Kalici vurgu (panelde secici uzerine gelindiginde). */
    highlightSelector(selector) {
        this.ensureNodes();
        if (!selector) {
            this.outline.style.display = "none";
            this.label.style.display = "none";
            return 0;
        }
        let nodes = [];
        try {
            nodes = document.querySelectorAll(selector);
        } catch (e) {
            return -1;
        }
        if (nodes.length === 0) {
            this.outline.style.display = "none";
            this.label.style.display = "none";
            return 0;
        }
        this.drawBox(nodes[0], selector + " · " + nodes.length);
        return nodes.length;
    }

    highlightElement(element) {
        if (!element || element.nodeType !== 1) return;
        if (this.root && this.root.contains(element)) return;
        this.hovered = element;

        const tag = element.tagName.toLowerCase();
        const firstClass =
            typeof element.className === "string" && element.className.trim()
                ? "." + element.className.trim().split(/\s+/)[0]
                : "";
        const label = tag + firstClass;
        let count = 0;
        try {
            count = label ? document.querySelectorAll(label).length : 0;
        } catch (e) {
            count = 0;
        }

        this.drawBox(element, count > 0 ? label + " · " + count : label);
    }

    drawBox(element, labelText) {
        const rect = element.getBoundingClientRect();
        this.outline.style.display = "block";
        this.outline.style.left = rect.left + "px";
        this.outline.style.top = rect.top + "px";
        this.outline.style.width = rect.width + "px";
        this.outline.style.height = rect.height + "px";

        this.label.style.display = "block";
        this.label.textContent = labelText;
        // Etiket elementin ustune sigmiyorsa altina alinir
        const above = rect.top > 26;
        this.label.style.left = Math.max(rect.left, 4) + "px";
        this.label.style.top = (above ? rect.top - 24 : rect.bottom + 4) + "px";
    }

    isActive() {
        return this.active;
    }
}

export const editorOverlay = new EditorOverlay();
export default editorOverlay;



//////////////////
// WEBPACK FOOTER
// ./static/src/tracker/editor/overlay.js
// module id = null
// module chunks = 